module.exports = __webpack_public_path__ + "img/bul_arr_left_gray.638b22ab.svg";